import {
  Component,
  HostListener,
  OnInit,
  ViewChild,
  ElementRef,
  ViewEncapsulation,
  Input,
  OnChanges, enableProdMode,
} from '@angular/core';
import { Observable } from 'rxjs';
import { CollapseSectionService, PagesEventService, Url } from 'src/app/common';
import { User, UserAuth } from 'src/app/common/user-auth';
import { InboxeViewModel } from '../../pages/default/time-management/models/inboxe.model';
import { NavbarGroup } from '../models/navbar.model';
import { LayoutService } from '../services/layout.service';
import { NavBarService } from '../services/navbar.service';
import { Router } from '@angular/router';
import * as jquery from 'jquery';
import { environment } from 'src/environments/environment';
import {AuthUtils} from '../../pages/default/finance/shared/auth-utils';

@Component({
  selector: 'app-leftbar',
  templateUrl: '../views/leftbar.component.html',
  styleUrls: ['../styles/leftbar.css'],
  encapsulation: ViewEncapsulation.None,
})
export class LeftbarComponent implements OnInit, OnChanges {
  userAuth: User = UserAuth.get();
  url = Url;
  version = { name: null, date: null };
  inboxeViewModel: InboxeViewModel = new InboxeViewModel();
  BORDER_THICKNESS = 2;
  @ViewChild('zoneSelect') zoneSelect!: ElementRef<HTMLDivElement>;
  environment = environment;
  overlay: any;
  outline: any;
  element: any;
  dimensions: any;
  permisions = {
    READ_PROJECT: this.userAuth.getAction('READ_PROJECT'),
    READ_MODULE: this.userAuth.getAction('READ_MODULE'),
    READ_EMPLOYEE_OVERVIEW: this.userAuth.getAction('READ_EMPLOYEE_OVERVIEW'),
    READ_EMPLOYEE_OWN: this.userAuth.getAction('READ_EMPLOYEE_OWN'),
    READ_FILIALE: this.userAuth.getAction('READ_FILIALE'),
    READ_TEMPLATES_POLICIES: this.userAuth.getAction('READ_TEMPLATES_POLICIES'),
    READ_ORGANIZATION_CHART: this.userAuth.getAction('READ_ORGANIZATION_CHART'),
    READ_CLIENT: this.userAuth.getAction('READ_CLIENT'),
    READ_PROJECT_TYPE: this.userAuth.getAction('READ_PROJECT_TYPE'),
    READ_PROJECT_JOURNAL_TAGS: this.userAuth.getAction('READ_PROJECT_JOURNAL_TAGS'),
    READ_PARTNER_OVERVIEW: (this.userAuth.getAction('READ_PARTNER_OVERVIEW') || this.userAuth.getAction('PARTNER_INFO_EDIT')) ? true : false,
    READ_RESOURCES_VEHICLES: this.userAuth.getAction('READ_RESOURCES_VEHICLES'),
    READ_QUALITY_CONTROL: this.userAuth.getAction('READ_QUALITY_CONTROL'),
    READ_RESOURCES_CONSTRUCTION_VEHICLES: this.userAuth.getAction(
      'READ_RESOURCES_CONSTRUCTION_VEHICLES'
    ),
    READ_RESOURCES_TRAILER_VEHICLES: this.userAuth.getAction(
      'READ_RESOURCES_TRAILER_VEHICLES'
    ),
    READ_RESOURCES_MEASURING_VEHICLES: this.userAuth.getAction(
      'READ_RESOURCES_MEASURING_VEHICLES'
    ),
    READ_RESOURCES_TOOLS: this.userAuth.getAction('READ_RESOURCES_TOOLS'),
    READ_RESOURCES_SPLICING_DEVICES: this.userAuth.getAction(
      'READ_RESOURCES_SPLICING_DEVICES'
    ),
    READ_RESOURCES_CONTAINER: this.userAuth.getAction(
      'READ_RESOURCES_CONTAINER'
    ),
    READ_FINANCE: this.userAuth.getAction('READ_FINANCE'),
    READ_OFFERS: this.userAuth.getAction('READ_OFFERS'),
    READ_COST_CENTER: this.userAuth.getAction('READ_COST_CENTER'),
    READ_SPECIFICATION: this.userAuth.getAction('READ_SPECIFICATION'),
    READ_EDIT_WEEKLY_REPORT:
      this.userAuth.getAction('READ_EDIT_WEEKLY_REPORT_OWN') ||
      this.userAuth.getAction('READ_EDIT_WEEKLY_REPORT_ALL_EMP')
        ? true
        : false,
    READ_EDIT_MONTHLY_REPORT:
      this.userAuth.getAction('READ_EDIT_MONTHLY_REPORT_ALL_EMP') ||
      this.userAuth.getAction('READ_EDIT_MONTHLY_REPORT_SUBORDINATE')
        ? true
        : false,
    READ_MONTHLY_EVALUATION: this.userAuth.getAction('READ_MONTHLY_EVALUATION')
      ? true
      : false,
    READ_ANNUAL_CALENDAR: this.userAuth.getAction('READ_ANNUAL_CALENDAR'),
    READ_INBOX:
      this.userAuth.getAction('READ_OWN_INBOX') ||
      this.userAuth.getAction('READ_ALL_INBOX')
        ? true
        : false,
    PRINT_WEEKLY_REPORT_ALL_EMP: this.userAuth.getAction(
      'PRINT_WEEKLY_REPORT_ALL_EMP'
    ),
    PRINT_MONTHLY_REPORT: this.userAuth.getAction('PRINT_MONTHLY_REPORT_OWN'),
    READ_EMP_FUNCTION: this.userAuth.getAction('READ_EMP_FUNCTION'),
    READ_WRITE_PAYOUTS: this.userAuth.getAction('READ_WRITE_PAYOUTS'),
    READ_TICKET_MANAGEMENT: this.userAuth.getAction('READ_TICKET_MANAGEMENT'),
    READ_TICKET: this.userAuth.getAction('READ_TICKET'),
    READ_MONTHLY_OVERVIEW:
      this.userAuth.getAction('READ_MONTHLY_OVERVIEW_SUBORDINATE') ||
      this.userAuth.getAction('READ_MONTHLY_OVERVIEW_ALL')
        ? true
        : false,
    READ_EDIT_EVALUATION_HOURS: this.userAuth.getAction(
      'READ_EDIT_EVALUATION_HOURS'
    ),
    READ_HOLIDAY_PLAN: this.userAuth.getAction('READ_HOLIDAY_PLAN'),
    READ_REPORTING:
      this.userAuth.getAction('READ_OWN_PROJECT_REPORTING') ||
      this.userAuth.getAction('READ_ALL_PROJECT_REPORTING')
        ? true
        : false,
    // READ_REPORTING_PERFORMANCE:
    //   this.userAuth.getAction('READ_REPORT_PERFORMANCE_ALL') ||
    //   this.userAuth.getAction('READ_REPORT_PERFORMANCE_SUBORDINATES')
    //     ? true
    //     : false,
    READ_EDIT_HOLIDAY_PLAN:
      this.userAuth.getAction('READ_EDIT_HOLIDAY_PLAN') ||
      this.userAuth.getAction('READ_EDIT_HOLIDAY_PLAN_ALL')
        ? true
        : false,
    READ_CALENDAR: this.userAuth.getAction('READ_CALENDAR'),
    READ_INTERNAL_PROJECTS:
      this.userAuth.getAction('READ_INTERNAL_PROJECTS') ||
      this.userAuth.getAction('EDIT_INTERNAL_PROJECTS')
        ? true
        : false,
    READ_REPORTING_PRODUCTION: this.userAuth.getAction(
      'READ_REPORTING_PRODUCTION'
    ),
    READ_WORK_PACKAGES: this.userAuth.getAction(
      'READ_WORK_PACKAGES'
    ),
    READ_REPORTING_PERFORMANCE: this.userAuth.getAction(
      'READ_REPORTING_PERFORMANCE'
    ),
    READ_REPORTING_QC: this.userAuth.getAction('READ_REPORTING_QC'),
    READ_REPORTING_TERMINE: this.userAuth.getAction('READ_REPORTING_TERMINE'),
    READ_REPORTING_DEVIATION: this.userAuth.getAction(
      'READ_REPORTING_DEVIATION'
    ),
    READ_REPORTING_SGA: this.userAuth.getAction(
      'READ_REPORTING_SGA'
    ),
    READ_KNOWLEDGE_MANAGEMENT: this.userAuth.getAction(
      'READ_KNOWLEDGE_MANAGEMENT'
    ),
    READ_AUDITS: this.userAuth.getAction(
      'READ_AUDITS'
    ),
    READ_REPORTING_ABSENCE: this.userAuth.getAction(
      'READ_REPORTING_ABSENCE'
    ),
    READ_TIME_MANAGEMENT_DEPUTY: this.userAuth.getAction('READ_TIME_MANAGEMENT_DEPUTY'),
    READ_JSON_TRANSLATIONS : this.userAuth.getAction('READ_JSON_TRANSLATIONS'),
    READ_PARTNER_EMPLOYEE_OVERVIEW : this.userAuth.getAction('READ_PARTNER_EMPLOYEE_OVERVIEW'),
    READ_TIME_MANAGEMENT_ANOMALY : this.userAuth.getAction('READ_TIME_MANAGEMENT_ANOMALY'),
    CREATE_SMS_TEMPLATE : this.userAuth.getAction('CREATE_SMS_TEMPLATE'),
  };

  group_permisions = {
    READ_TIME_MANAGEMENT:
      this.permisions.READ_EDIT_WEEKLY_REPORT ||
      this.permisions.READ_EDIT_MONTHLY_REPORT ||
      this.permisions.READ_ANNUAL_CALENDAR ||
      this.permisions.READ_INBOX ||
      this.permisions.READ_MONTHLY_OVERVIEW ||
      this.permisions.READ_WRITE_PAYOUTS ||
      this.permisions.READ_HOLIDAY_PLAN ||
      this.permisions.READ_EDIT_HOLIDAY_PLAN ||
      this.permisions.READ_EDIT_EVALUATION_HOURS ||
      this.permisions.PRINT_MONTHLY_REPORT ||
      this.permisions.PRINT_WEEKLY_REPORT_ALL_EMP ||
      this.permisions.READ_INTERNAL_PROJECTS ||
      this.permisions.READ_MONTHLY_EVALUATION,

    READ_FINANCE:
      this.permisions.READ_FINANCE ||
      this.permisions.READ_COST_CENTER ||
      this.permisions.READ_OFFERS ||
      this.permisions.READ_SPECIFICATION,

    READ_EMPLOYEE:
      this.permisions.READ_EMPLOYEE_OVERVIEW ||
      this.permisions.READ_CALENDAR ||
      this.permisions.READ_ORGANIZATION_CHART ||
      this.permisions.READ_EMP_FUNCTION ||
      this.permisions.READ_EMPLOYEE_OWN,
  };
  defulatGroups: NavbarGroup[] = [
    {
      name: 'Home',
      icon: 'home.svg',
      collapsed: true,
      visible: true,
      routeLink: '/home',
      items: [],
    },
    {
      name: 'projects',
      icon: 'project.svg',
      collapsed: true,
      visible: this.permisions.READ_PROJECT,
      items: [
        { name: 'overview projects', routerLink: '/project', visible: true },
        {
          name: 'modules',
          routerLink: '/project/module',
          visible: this.permisions.READ_MODULE,
        },
        {
          name: 'templates',
          routerLink: '/project/template',
          visible: this.url.isDev,
        },
        {
          name: 'Internal Projects',
          routerLink: '/project/internal-projects',
          visible: this.permisions.READ_INTERNAL_PROJECTS,
        },
      ],
    },
    {
      name: 'personal',
      icon: 'employee.svg',
      collapsed: true,
      visible: this.group_permisions.READ_EMPLOYEE,
      items: [
        {
          name: 'Employee Details',
          routerLink: '/employee/personal',
          visible: this.permisions.READ_EMPLOYEE_OWN,
        },
        {
          name: 'employee overview',
          routerLink: '/employee',
          visible: this.permisions.READ_EMPLOYEE_OVERVIEW,
        },
        {
          name: 'calendar',
          routerLink: '/employee/calendar',
          visible: this.permisions.READ_CALENDAR,
        },
        {
          name: 'Calendar (New)',
          routerLink: '/employee/calendar-new',
          visible: this.permisions.READ_CALENDAR && (this.userAuth.id == 35 || this.userAuth.id == 130),
        },
        {
          name: 'organization chart',
          routerLink: '/employee/tree',
          visible: this.permisions.READ_ORGANIZATION_CHART,
        },
        {
          name: 'Employee Function',
          routerLink: '/employee/functions',
          visible: this.permisions.READ_EMP_FUNCTION,
        },
        {
          name: 'MitarbeiterAktionen',
          routerLink: '/employee/empActions',
          visible:
            this.permisions.READ_EMP_FUNCTION &&
            (this.url.isDev ||
              this.userAuth.id == 102 ||
              this.userAuth.id == 707),
        },
      ],
    },
    {
      name: 'external services',
      icon: 'partner.svg',
      collapsed: true,
      visible: this.permisions.READ_PARTNER_OVERVIEW,
      items: [
        {
          name: 'Übersicht Partners',
          routerLink: '/partner',
          visible: this.permisions.READ_PARTNER_OVERVIEW,
        },
        {
          name: 'Übersicht Mitarbeiter',
          routerLink: '/partner/extern-employee',
          visible: this.permisions.READ_PARTNER_EMPLOYEE_OVERVIEW,
        },
      ],
    },
    {
      name: 'resource',
      icon: 'resource.svg',
      collapsed: true,
      visible: this.permisions.READ_RESOURCES_VEHICLES,
      items: [
        {
          name: 'Vehicle',
          routerLink: '/resource/Vehicle',
          visible: this.permisions.READ_RESOURCES_VEHICLES,
        },
        {
          name: 'ConstructionVehicle',
          routerLink: '/resource/ConstructionVehicle',
          visible: this.permisions.READ_RESOURCES_CONSTRUCTION_VEHICLES,
        },
        {
          name: 'Trailer',
          routerLink: '/resource/Trailer',
          visible: this.permisions.READ_RESOURCES_TRAILER_VEHICLES,
        },
        {
          name: 'Device',
          routerLink: '/resource/Device',
          visible: this.permisions.READ_RESOURCES_MEASURING_VEHICLES,
        },
        {
          name: 'Tool',
          routerLink: '/resource/Tool',
          visible: this.permisions.READ_RESOURCES_TOOLS,
        },
        {
          name: 'Splicer',
          routerLink: '/resource/Splicer',
          visible: this.permisions.READ_RESOURCES_SPLICING_DEVICES,
        },
        {
          name: 'Container',
          routerLink: '/resource/Container',
          visible: this.permisions.READ_RESOURCES_CONTAINER,
        },
      ],
    },
    {
      name: 'Personal equipment',
      icon: 'equipment.svg',
      collapsed: true,
      visible: this.userAuth.id == 1,
      items: [
        { name: 'Badge', routerLink: '/equipment/badge', visible: true },
        {
          name: 'Mobile device',
          routerLink: '/equipment/mobile',
          visible: true,
        },
        {
          name: 'External account',
          routerLink: '/equipment/extAccount',
          visible: true,
        },
      ],
    },
    {
      name: 'Safety equipment',
      icon: 'safety.svg',
      collapsed: true,
      visible: this.userAuth.partnerId == null,
      items: [
        {
          name: 'FirstAidKit',
          routerLink: '/safety-equipment/FirstAidKit',
          visible: true,
        },
        {
          name: 'FireExtinguisher',
          routerLink: '/safety-equipment/FireExtinguisher',
          visible: true,
        },
        {
          name: 'SpecialEquipment',
          routerLink: '/safety-equipment/SpecialEquipment',
          visible: true,
        },
      ],
    },
    {
      name: 'finances',
      icon: 'finance.svg',
      collapsed: true,
      visible: this.group_permisions.READ_FINANCE,
      items: [
        {
          name: 'offers',
          routerLink: '/finance/offers',
          visible: this.permisions.READ_OFFERS && this.url.isStaging,
        },
        {
          name: 'orders',
          routerLink: '/finance',
          visible: this.permisions.READ_FINANCE,
        },
        {
          name: 'costCenters',
          routerLink: '/finance/costCenters',
          visible: this.permisions.READ_COST_CENTER,
        },
        {
          name: 'specifications',
          routerLink: '/finance/priceTable',
          visible: this.permisions.READ_SPECIFICATION,
        },
        {
          name: 'Service List Breakdown',
          routerLink: '/settings/service-list-breakdown',
          visible: this.permisions.READ_FINANCE && this.isUserAllowedFinance,
        },
         {
          name: 'Price Change Requests',
          routerLink: '/finance/price-change-requests',
          visible: this.permisions.READ_FINANCE && this.isUserAllowedFinance,
        },
        {
          name: 'overview',
          routerLink: '/finance/overview',
          visible: this.permisions.READ_FINANCE && this.isUserAllowedFinance,
        },
        {
           name: 'reporting',
           routerLink: '/finance/reporting-new',
           visible: this.permisions.READ_FINANCE && this.isUserAllowedFinance,
         },
        // {
        //    name: 'Partner order managment',
        //    routerLink: '/finance/partner-order-managment',
        //    visible: this.permisions.READ_FINANCE && this.isUserAllowedFinance,
        //  },
        // {
        //   name: 'reporting',
        //   routerLink: '/finance/reporting',
        //   visible: this.permisions.READ_FINANCE && this.isUserAllowedFinance,
        // },
        {
          name: 'data',
          routerLink: '/finance/data',
          visible: this.permisions.READ_FINANCE && this.isUserAllowedFinance,
        },
      ],
    },
    {
      name: 'Time Management',
      icon: 'time-management.svg',
      collapsed: true,
      visible:
        this.group_permisions.READ_TIME_MANAGEMENT &&
        this.userAuth.extern !== 2,
      items: [
        {
          name: 'Inbox',
          routerLink: '/time-management/inbox',
          visible: this.permisions.READ_INBOX,
        },
        {
          name: 'Weekly Report',
          routerLink: '/time-management',
          visible: this.permisions.READ_EDIT_WEEKLY_REPORT,
        },
        {
          name: 'Monthly Report',
          routerLink: '/time-management/monthly',
          visible: this.permisions.READ_EDIT_MONTHLY_REPORT,
        },
        {
          name: 'Calendar',
          routerLink: '/time-management/calendars',
          visible: this.permisions.READ_ANNUAL_CALENDAR,
        },
        {
          name: 'Monthly Overview',
          routerLink: '/time-management/monthly/overview',
          visible: this.permisions.READ_MONTHLY_OVERVIEW,
        },
        {
          name: 'monthly evaluation',
          routerLink: '/time-management/monthly/evaluation',
          visible: this.permisions.READ_MONTHLY_EVALUATION,
        },
        {
          name: 'Payout',
          routerLink: '/time-management/payout',
          visible: this.permisions.READ_WRITE_PAYOUTS,
        },
        {
          name: 'vacation schedule',
          routerLink: '/time-management/vacationTimeline',
          visible: this.permisions.READ_HOLIDAY_PLAN,
        },
        {
          name: 'plan vacation',
          routerLink: '/time-management/vacationPlaning',
          visible: this.permisions.READ_EDIT_HOLIDAY_PLAN,
        },
        {
          name: 'Evaluation Hours',
          routerLink: '/time-management/evaluation-hours',
          visible: this.permisions.READ_EDIT_EVALUATION_HOURS,
        },
        {
          name: 'Deputy',
          routerLink: '/time-management/subtitute/history',
          visible: this.permisions.READ_TIME_MANAGEMENT_DEPUTY,
        },
        {
          name: 'Anomalies',
          routerLink: '/time-management/anomaly-snapshot',
          visible: this.permisions.READ_TIME_MANAGEMENT_ANOMALY,
        },
      ],
    },
    {
      name: 'Reporting',
      icon: 'report.svg',
      collapsed: true,
      visible: this.permisions.READ_REPORTING_PRODUCTION,
      items: [
        {
          name: 'Produktion FTTH',
          routerLink: '/report/production',
          visible: this.permisions.READ_REPORTING_PRODUCTION,
        },
        {
          name: 'Produktion CU-Phaseout',
          routerLink: '/report/production-cu',
          visible: this.permisions.READ_REPORTING_PRODUCTION,
        },
        {
          name: 'Arbeitspakete',
          routerLink: '/report/work-packages',
          visible: this.permisions.READ_WORK_PACKAGES,
        },
        // {
        //   name: 'Performance',
        //   routerLink: '/report/performance/selectionMask',
        //   visible: this.permisions.READ_REPORTING_PERFORMANCE,
        // },
        // {
        //   name: 'Dokumentation QC',
        //   routerLink: '/report/qs',
        //   visible: this.permisions.READ_REPORTING_QC,
        // },
        {
          name: 'Dokumentation QC',
          routerLink: '/report/quality-control',
          visible: this.permisions.READ_REPORTING_QC,
        },
        {
          name: 'Termine',
          routerLink: '/report/termine',
          visible: this.permisions.READ_REPORTING_TERMINE,
        },
        {
          name: 'Deviations',
          routerLink: '/report/deviations',
          visible: this.permisions.READ_REPORTING_DEVIATION,
        },
        {
          name: 'Planung',
          routerLink: '/report/planning',
          visible: this.permisions.READ_REPORTING_DEVIATION,
        },
        {
          name: 'SGA',
          routerLink: '/report/sga',
          visible: this.permisions.READ_REPORTING_ABSENCE,
        },
      ],
    },
    {
      name: 'Settings',
      icon: 'settings.svg',
      collapsed: true,
      visible: this.permisions.READ_FILIALE,
      items: [
       {
          name: 'Journal Accounts',
          routerLink: '/settings/journal-accounts',
          visible: this.permisions.READ_FINANCE && this.isUserAllowedFinance,
        },{
          name: 'Service List',
          routerLink: '/settings/service-list',
          visible: this.permisions.READ_FINANCE && this.isUserAllowedFinance,
        },{
          name: 'permanent_establishment',
          routerLink: '/settings/office',
          visible: this.permisions.READ_FILIALE,
        },
        {
          name: 'client',
          routerLink: '/settings/client',
          visible: this.permisions.READ_CLIENT,
        },
        {
          name: 'project_types',
          routerLink: '/settings/project-type',
          visible: this.permisions.READ_PROJECT_TYPE,
        },
        {
          name: 'access_networks',
          routerLink: '/settings/access-networks',
          visible: this.permisions.READ_PROJECT_TYPE,
        },
        {
          name: 'Json Translation',
          routerLink: '/settings/json-translation',
          visible: this.permisions.READ_JSON_TRANSLATIONS,
        },
        {
          name: 'projektJournalTags',
          routerLink: '/settings/project-journal-tags',
          visible: this.permisions.READ_PROJECT_JOURNAL_TAGS,
        },
        {
          name: 'Notification Templates',
          routerLink: '/settings/sms-template',
          visible: this.permisions.CREATE_SMS_TEMPLATE,
        },
        {
          name: 'Notification Outbox',
          routerLink: '/settings/sms-queue',
          visible: this.permisions.CREATE_SMS_TEMPLATE,
        },
        {
          name: 'System Module',
          routerLink: '/settings/system-module',
          visible: this.url.isDev || this.userAuth.id === 1 || this.userAuth.id === 1222 || this.userAuth.id === 35 || this.userAuth.id === 849,
        },
      ],
    },
    {
      name: 'Templates & guidelines',
      icon: 'document.svg',
      collapsed: true,
      visible: this.permisions.READ_TEMPLATES_POLICIES,
      items: [
        {
          name: 'Templates & guidelines',
          routerLink: '/document',
          visible: true,
        },
      ],
    },
    {
      name: 'Ticket',
      icon: 'ticket.svg',
      collapsed: true,
      visible: true,
      items: [
        {
          name: 'Ticket',
          routerLink: '/ticket',
          visible: this.permisions.READ_TICKET,
        },
        {
          name: 'Ticket management',
          routerLink: '/ticket/group',
          visible: this.permisions.READ_TICKET_MANAGEMENT,
        },{
          name: 'Tickets Report',
          routerLink: '/ticket/report',
          visible: (this.userAuth.id == 3 || this.userAuth.id == 35 || this.userAuth.id == 849),
        },
      ],
    },
    {
      name: 'Knowledge Management',
      icon: 'book.svg',
      collapsed: true,
      visible: this.permisions.READ_KNOWLEDGE_MANAGEMENT,
      routeLink: '/libraries',
      items: [],
    },
    {
      name: 'Learnmanagement',
      icon: 'book.svg',
      collapsed: true,
      visible: this.permisions.READ_KNOWLEDGE_MANAGEMENT && this.url.isDev,
      items: [
        {
          name: 'Knowledge Management',
          routerLink: '/libraries',
          visible: this.permisions.READ_KNOWLEDGE_MANAGEMENT,
        },
        {
          name: 'E Learning',
          routerLink: '/e-learning',
          visible:this.url.isDev || this.userAuth.id === 1 || this.userAuth.id === 35 || this.userAuth.id === 517,
        },
      ],
    },
    {
      name: 'Audit',
      icon: 'audit.svg',
      collapsed: true,
      visible: this.permisions.READ_AUDITS,
      items: [
        {
          name: 'Audit Protocols',
          routerLink: '/audit',
          visible: this.permisions.READ_AUDITS
        },
        {
          name: 'Audit Settings',
          routerLink: '/audit/setting',
          visible: this.permisions.READ_AUDITS
        },
      ],
    },
  ];
  @Input() navbarGroup: NavbarGroup[] = [];

  groups: NavbarGroup[] = this.defulatGroups;
  appVersion = Url.appVersion;
  selectedGroup: NavbarGroup = null;
  isCollapsed$: Observable<boolean> = null;
  isCollapsedKnowladge$: Observable<boolean> = null;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: any): void {
    this.hideCollapsedItems(event.target); // menu panel
  }

  @HostListener('window:resize', [])
  onResize() {
    this.navBarService.onWindowsResize(window.innerWidth);
  }

  constructor(
    private navBarService: NavBarService,
    public layoutService: LayoutService,
    public pagesEventService: PagesEventService,
    public collapseSectionService: CollapseSectionService,
    private router: Router
  ) {
    this.pagesEventService.changeInbox.subscribe((value) => {
      if (value === 'change-inbox') {
        this.getInboxes();
      }
    });
  }

  ngOnChanges(changes): void {
    this.groups = changes.navbarGroup.currentValue;
  }

  ngOnInit(): void {
    this.isCollapsed$ = this.navBarService.isCollapsed$;
    this.isCollapsedKnowladge$ = this.navBarService.isCollapseKnowledge$;
    Promise.resolve().then(() =>
      this.navBarService.isSmallDevice(window.innerWidth)
    );
    /**/

    //this.zoneSelect.nativeElement.style.background = 'red';
    // const collapseSectionService = this.collapseSectionService;

    // document.addEventListener('click', (e:any) => {
    //   const target = e.target;

    //   console.log(target);
    //   if (target.classList.contains('collapse-header')) {
    //     if (target.classList.contains('dont-collapse')) return;

    //     const parent = target.parentElement;
    //     parent.classList.toggle('open');

    //     if (parent.id) {
    //       collapseSectionService.setSection(
    //         parent.id,
    //         parent.classList.contains('open') ? 1 : 0
    //       );
    //     }
    //   }
    // });

    var collapseSectionService = this.collapseSectionService;
    $(document).on('click', '.collapse-header', function (e) {
      if (e.currentTarget.classList.contains('dont-collapse')) return;
      $(this).parent().toggleClass('open');
      if (typeof $(this).parent().attr('id') != 'undefined') {
        collapseSectionService.setSection(
          $(this).parent().attr('id'),
          $(this).parent().hasClass('open') ? 1 : 0
        );
      }
    });



    this.getInboxes();
    this.getNewVersionAlert();
    if (this.permisions.READ_FINANCE) this.getFinanceNewOrders();
  }

  getNewVersionAlert() {
    this.layoutService.getNewVersionAlert().subscribe((response) => {
      if (response.Status == 200 && response.Version) {
        this.version = response.Version;
      }
    });
  }

  toggleSideBar() {
    if (this.navbarGroup.length) {
      this.navBarService.toggleKnowledge();
    } else {
      this.navBarService.toggle();
    }
  }

  hideCollapsedItems(target: Element) {
    if (
      !(
        target?.parentElement?.nodeName == 'LI' &&
        target?.parentElement?.parentElement.classList.contains('leftbar-items')
      )
    )
      this.selectedGroup = null;
  }

  onGroupeClick(group: NavbarGroup, grouElement: any) {
    if (group.routeLink) {
      this.router.navigate([group.routeLink]);
      return;
    }
    this.toggleGroup(group, grouElement);
  }

  toggleGroup(group: NavbarGroup, grouElement: any) {
    group.top =
      this.navbarGroup.length &&
      this.router.url.startsWith('/libraries/page/versions')
        ? grouElement.offsetTop + 293
        : this.navbarGroup.length &&
          this.router.url.startsWith('/libraries/page')
        ? grouElement.offsetTop + 222
        : this.navbarGroup.length && this.router.url.startsWith('/libraries')
        ? grouElement.offsetTop + 435
        : grouElement.offsetTop + 0;
    if (this.navbarGroup.length && this.navBarService.isCollapsedKnowledge())
      this.selectedGroup = group;
    if (!this.navbarGroup.length && this.navBarService.isCollapsed())
      this.selectedGroup = group;
    else group.collapsed = !group.collapsed;
  }

  getFinanceNewOrders() {
    this.layoutService.getFinanceNewOrders().subscribe((response) => {
      if (response.Status == 200 && response.OrdersNr > 0) {
        let group = this.groups.find((gr) => gr.name == 'finances');
        if (group) {
          group.badge = false;
        }
      }
    });
  }

  getInboxes() {
    this.layoutService.getInboxes(this.userAuth.id).subscribe((response) => {
      if (response.Status == 200) {
        this.inboxeViewModel.inboxes = response.inboxes;
        let unReadConfirmation = this.inboxeViewModel.inboxes.find(
          (inbox) => inbox.readAt == null
        );
        let group = this.groups.find((gr) => gr.name == 'Time Management');

        if (group) {
          let item = group.items.find((item) => item.name == 'Inbox');
          if (item) {
            item.badge = !!unReadConfirmation;
          }
        }
      }
    });
  }

  getAssignedToMeNew() {
    this.layoutService
      .getAssignedToMeNew({ id: this.userAuth.id })
      .subscribe((response) => {
        if (response.TicketsAssignedToMe?.count > 0) {
          let group = this.groups.find((gr) => gr.name == 'Ticket');
          if (group) {
            group.badge = true;
          }
        }
      });
  }

  navigateToHomePage = () => {
    this.router.navigate(['/home']);
  };

  navigateToVersionPage = () => {
    if (!this.userAuth.isExternal) {
      this.router.navigate(['versioning/list']);
    }
  };

  get isUserAllowedFinance(): boolean {
    return AuthUtils.isAllowed(this.userAuth?.id);;
  }
}
